import * as CL from '@design-system/component-library';
import { AdditionalBillReceiversEdit } from '../../components/AdditionalBillReceiversEdit.js';
import { BillReceiverEdit } from '../../components/BillReceiverEdit.js';
import { DeliveryMethodAndLanguageSelection } from '../../components/DeliveryMethodAndLanguageSelection.js';
import type { CLDropdownItem } from '../../../../common/types/componentLibrary';
import type { Contact } from '../../../../generated/api/contact.js';

interface BillingAccountEmailDeliveryMethodProps {
  deliveryMethodOptions: CLDropdownItem[];
  disabled?: boolean;
  contacts: Contact[];
  onDeliveryMethodChange?: (newMethod: string) => void;
  onCreateContact?: () => void;
}

export const BillingAccountEmailDeliveryMethodEdit = ({
  deliveryMethodOptions,
  disabled = false,
  contacts,
  onDeliveryMethodChange,
  onCreateContact,
}: BillingAccountEmailDeliveryMethodProps) => (
  <>
    <DeliveryMethodAndLanguageSelection
      deliveryMethodOptions={deliveryMethodOptions}
      disabled={disabled}
      onDeliveryMethodChange={onDeliveryMethodChange}
    />
    <BillReceiverEdit disabled={disabled} contacts={contacts} onCreateContact={onCreateContact} />
    <CL.GridRow>
      <AdditionalBillReceiversEdit disabled={disabled} />
    </CL.GridRow>
  </>
);
